/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Edit_Light_No_AdminInputs */



/**
* | output |
* | --- |
* | "A member with a Light seat can't be an admin. To make them one, first change their seat type: in the members list, open the menu next to them and choose “Cha..." |
*
* @param {Members_Edit_Light_No_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_edit_light_no_admin = /** @type {((inputs?: Members_Edit_Light_No_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Edit_Light_No_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Mitglied mit einem Light-Platz kann kein Administrator sein. Ändern Sie dazu zuerst den Platztyp: Öffnen Sie in der Mitgliederliste das Menü neben dem Mitglied und wählen Sie „Platztyp ändern“.")
	return /** @type {LocalizedString} */ ("A member with a Light seat can't be an admin. To make them one, first change their seat type: in the members list, open the menu next to them and choose “Change seat type”.")
});